import { CompanyContact } from '@models/business/CompanyContact'
import { selectCompanyContactsByIds } from '@store/business/CompanyContactReducer'
import { useAppSelector } from '@store/hooks'
import { SBModelsComponent } from '@supplement-bacon/react-toolkit/models'
import { Avatar, Tooltip } from 'antd'

type Props = SBModelsComponent<CompanyContact> & {}

export const GroupAvatar = ({ ids, models }: Props) => {
  const items = models
    ? models
    : useAppSelector(selectCompanyContactsByIds(ids ?? []))

  if (!items) {
    return <></>
  }

  return (
    <Avatar.Group
      max={{
        count: 4,
        style: { backgroundColor: '#8e978a' },
      }}
    >
      {items.map((item) => (
        <Tooltip title={item.lastName + ' ' + item.firstName} key={item.id}>
          <Avatar style={{ backgroundColor: '#8e978a' }}>
            <div style={{ textTransform: 'uppercase' }}>
              {item.firstName && item.firstName.slice(0, 1)}
              {item.lastName && item.lastName.slice(0, 1)}
              {!item.firstName && !item.lastName && '--'}
            </div>
          </Avatar>
        </Tooltip>
      ))}
    </Avatar.Group>
  )
}

export type GroupAvatarType = { GroupAvatar: typeof GroupAvatar }
